"use client";

import { c as _c } from "react/compiler-runtime";
import { useControllableState } from "@radix-ui/react-use-controllable-state";
import { useState } from "react";
import * as React from "react";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Popover, PopoverContent, PopoverTrigger, PopoverAnchor } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
export function AssignToPopover(t0) {
  const $ = _c(23);
  const {
    users,
    defaultAssignee,
    assignee,
    onAssigneeChange,
    disabled
  } = t0;
  const [open, setOpen] = useState(false);
  const t1 = defaultAssignee || null;
  let t2;
  if ($[0] !== assignee || $[1] !== onAssigneeChange || $[2] !== t1) {
    t2 = {
      prop: assignee,
      defaultProp: t1,
      onChange: onAssigneeChange
    };
    $[0] = assignee;
    $[1] = onAssigneeChange;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [selectedUser, setSelecteduser] = useControllableState(t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <PopoverAnchor />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== selectedUser) {
    t4 = <div className="flex items-center gap-2">Assignee:{selectedUser ? <><Avatar className="h-5 w-5"><AvatarImage src={selectedUser.avatarUrl ?? ""} alt={selectedUser.name} className="grayscale" /><AvatarFallback name={selectedUser.name} /></Avatar>{selectedUser.name}</> : <span>+ Assign to</span>}</div>;
    $[5] = selectedUser;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== disabled) {
    t5 = <PopoverTrigger asChild={true}><Button variant="link" className="px-0 underline hover:decoration-2 active:decoration-2 active:underline-offset-[6px]" disabled={disabled}>change</Button></PopoverTrigger>;
    $[7] = disabled;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <CommandInput placeholder="Assign to..." />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <CommandEmpty>No results found.</CommandEmpty>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== setSelecteduser || $[12] !== users) {
    t8 = users.map(user => <CommandItem key={user.id} value={user.name} onSelect={value => {
      const user_0 = users.find(u => u.name === value) || null;
      setSelecteduser(user_0);
      setOpen(false);
    }}><Avatar className="mr-2 h-5 w-5 text-slate-12"><AvatarImage src={user.avatarUrl ?? ""} alt={user.name} className="grayscale" /><AvatarFallback name={user.name} /></Avatar>{user.name}</CommandItem>);
    $[11] = setSelecteduser;
    $[12] = users;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <PopoverContent className="p-0" side="right" align="start"><Command>{t6}<CommandList>{t7}<CommandGroup>{t8}</CommandGroup></CommandList></Command></PopoverContent>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t4 || $[17] !== t5 || $[18] !== t9) {
    t10 = <div className="flex items-center gap-2 rounded bg-slate-3 py-[1px] pl-2 pr-4">{t3}{t4}{t5}{t9}</div>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== open || $[21] !== t10) {
    t11 = <Popover open={open} onOpenChange={setOpen}>{t10}</Popover>;
    $[20] = open;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
}